import { AlertTriangle } from 'lucide-react';

interface Props {
  title: string;
  busy: boolean;
  onCancel: () => void;
  onConfirm: () => Promise<void>;
}

export function ConfirmDialog({ title, busy, onCancel, onConfirm }: Props) {
  return (
    <div className="modal-backdrop confirm-backdrop" role="presentation">
      <section className="confirm-dialog" role="alertdialog" aria-modal="true" aria-labelledby="confirm-title">
        <AlertTriangle size={24} aria-hidden="true" />
        <h2 id="confirm-title">確認刪除</h2>
        <p>確定要刪除「{title}」嗎？</p>
        <div className="form-actions">
          <button type="button" className="text-button" onClick={onCancel} disabled={busy}>取消</button>
          <button type="button" className="danger-button" onClick={onConfirm} disabled={busy}>{busy ? '刪除中…' : '刪除'}</button>
        </div>
      </section>
    </div>
  );
}
